/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleAnalyticsPropertyData
 */
export interface GoogleAnalyticsPropertyData {
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsPropertyData
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsPropertyData
     */
    accountDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsPropertyData
     */
    propertyId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsPropertyData
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsPropertyData
     */
    propertyType?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsPropertyData
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsPropertyData
     */
    currencyCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAnalyticsPropertyData
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAnalyticsPropertyData
     */
    available?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleAnalyticsPropertyData
     */
    demographicsEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsPropertyData
     */
    discoveredAt?: string;
}

/**
 * Check if a given object implements the GoogleAnalyticsPropertyData interface.
 */
export function instanceOfGoogleAnalyticsPropertyData(value: object): value is GoogleAnalyticsPropertyData {
    return true;
}

export function GoogleAnalyticsPropertyDataFromJSON(json: any): GoogleAnalyticsPropertyData {
    return GoogleAnalyticsPropertyDataFromJSONTyped(json, false);
}

export function GoogleAnalyticsPropertyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAnalyticsPropertyData {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'accountDisplayName': json['accountDisplayName'] == null ? undefined : json['accountDisplayName'],
        'propertyId': json['propertyId'] == null ? undefined : json['propertyId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'propertyType': json['propertyType'] == null ? undefined : json['propertyType'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'available': json['available'] == null ? undefined : json['available'],
        'demographicsEnabled': json['demographicsEnabled'] == null ? undefined : json['demographicsEnabled'],
        'discoveredAt': json['discoveredAt'] == null ? undefined : json['discoveredAt'],
    };
}

export function GoogleAnalyticsPropertyDataToJSON(json: any): GoogleAnalyticsPropertyData {
    return GoogleAnalyticsPropertyDataToJSONTyped(json, false);
}

export function GoogleAnalyticsPropertyDataToJSONTyped(value?: GoogleAnalyticsPropertyData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountId': value['accountId'],
        'accountDisplayName': value['accountDisplayName'],
        'propertyId': value['propertyId'],
        'displayName': value['displayName'],
        'propertyType': value['propertyType'],
        'timeZone': value['timeZone'],
        'currencyCode': value['currencyCode'],
        'enabled': value['enabled'],
        'available': value['available'],
        'demographicsEnabled': value['demographicsEnabled'],
        'discoveredAt': value['discoveredAt'],
    };
}

